import React, { useRef } from 'react';
import cn from 'classnames';
import { Button, Form, Grid, Input, Select, TextArea, View } from 'src/components/common';
import './styles.scss';
import { IRootState } from 'src/redux/rootReducer';
import { connect } from 'react-redux';
import { ErrorService, Yup } from 'src/services';
import { Formik, FormikProps } from 'formik';

import { JobInfo, JobModalTypes } from 'src/redux/jobcodes/types';
import { addJobAsync, updateJobAsync } from 'src/redux/jobcodes/actions';
import { CustomModal } from 'src/components/Modal';

const JobSchema = Yup.object().shape({
  code: Yup.string()
    // .typeError(jobCodeError)
    .test('len', ErrorService.MESSAGES.invalidJobCode, val => (val?.toString()?.length || 0) === 4 && !val.match(/\D/i))
    .required(),
  description: Yup.string().max(255, ErrorService.MESSAGES.descriptionMaxLength).required(),
  status: Yup.string().typeError(ErrorService.MESSAGES.required).required(),
});

const JobsModal: React.FC<Props> = ({ loading, data, openModalType, onClose, onUpdateJob, onAddJob, status }) => {
  const formRef = useRef<FormikProps<JobInfo>>(null);

  const handleSubmit = (value: JobInfo) => {
    if (openModalType === JobModalTypes.ADD) onAddJob(value);
    if (openModalType === JobModalTypes.EDIT) onUpdateJob(value);
  };

  const renderTitle = () => {
    switch (openModalType) {
      case JobModalTypes.EDIT:
        return <h3>Edit Job Number</h3>;
      case JobModalTypes.ADD:
        return <h3>Add Job Number</h3>;
    }
  };

  const renderBody = modalType => (
    <Formik
      key={`job-codes-modal-${modalType}`}
      initialValues={data}
      onSubmit={handleSubmit}
      validationSchema={JobSchema}
      innerRef={formRef}>
      {({ handleSubmit, errors, touched, getFieldProps, setFieldValue, setFieldTouched }) => (
        <Form preventDefault autoComplete="off" className="ctn-uam__form">
          <Grid.Wrap>
            <Grid.Item>
              <Input
                label="Code *"
                placeholder="Code"
                errorMessage={touched.code ? errors.code : ''}
                {...getFieldProps('code')}
                disabled={modalType === JobModalTypes.EDIT}
              />
            </Grid.Item>
            <Grid.Item>
              <Select
                creatable={false}
                options={status || []}
                label="Status *"
                placeholder="Choose Here ..."
                errorMessage={touched.status ? errors.status : ''}
                {...getFieldProps('status')}
                name="status"
                onChange={setFieldValue}
                onBlur={setFieldTouched}
              />
            </Grid.Item>
            <Grid.Item>
              <TextArea
                label="Description *"
                placeholder="Description"
                errorMessage={touched.description ? errors.description : ''}
                {...getFieldProps('description')}
              />
            </Grid.Item>
          </Grid.Wrap>
          <View className={cn('ctn-jobcodes-modal__footer')}>
            <View flexGrow={1} justify={'flex-end'} isRow className={'mt-32'}>
              <Button label={'CANCEL'} onClick={onClose} className={cn('mr-5')} variant={'outline'} type={'button'} />
              <Button type={'button'} onClick={() => handleSubmit()} isLoading={loading}>
                {modalType === JobModalTypes.EDIT ? 'UPDATE' : 'ADD'}
              </Button>
            </View>
          </View>
        </Form>
      )}
    </Formik>
  );

  return <CustomModal openModalType={openModalType} header={renderTitle()} body={renderBody(openModalType)} />;
};

type Props = ReturnType<typeof mapStateToProps> &
  typeof mapDispatchToProps & {
    onClose?: () => void;
  };

const mapStateToProps = (state: IRootState) => ({
  data: state.jobCodes.selectedJob,
  loading: state.jobCodes.isLoading,
  openModalType: state.jobCodes.openModalType,
  status: state.content.status,
});

const mapDispatchToProps = {
  onUpdateJob: updateJobAsync.request,
  onAddJob: addJobAsync.request,
};

export default connect(mapStateToProps, mapDispatchToProps)(JobsModal);
